import { TransactionStatusEntity } from '../entities/transaction-status-entity';

export default class State {
  loaded = false;

  items: Array<TransactionStatusEntity> = [];
}
